import { baseSiteEndPoint, buildHeaders, getSellerID, processResponse } from "./common";
import { authorizedFetch } from "./login";

export const apiSimulationTax = (value, sellerManual) =>
  authorizedFetch(`${baseSiteEndPoint}/sales/seller/${sellerManual ? sellerManual : getSellerID()}/simulate`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify({ amount: value, is_online: true })
  }).then(processResponse);
